export const EVENT_LOCATIONS = `
    query eventLocations($event_id: Uint) {
        eventLocations(event_id: $event_id) {
            id
            name
            description
            attendee_description
            image_url
            button_text
            link
            point_value
            created_at
            updated_at
        }
    }
  `;
